<div class="backdrop" [class.visible]="isOpened" (click)="closeMenu()"></div>
<main class="hamburger-menu hamburger-menu-transition" [@slideInOut]="isOpened ? 'in' : 'out'">
  <mat-icon class="hamburger-menu-close cursor-pointer" (click)="closeMenu()">close</mat-icon>

  <section class="hamburger-menu-items">
    <img src="assets/svg/logo.svg" alt="logo">

    <div class="flex-direction-column">
      @for (page of pages[0]; track page) {
        <span [class]="currentRoute == page.routerLink ? 'active' : ''" class="hamburger-menu-item" [routerLink]="page.routerLink">{{ page.name | translate }}</span>
      }
      <img src="assets/svg/hamburger-devider.svg" alt="devider" class="devider">

      @if (!hasCurrentUser) {
        <span class="hamburger-menu-item" [routerLink]="'/login'">{{ 'home-page-content.login' | translate }}</span>
      } @else {
        <span class="hamburger-menu-item" [routerLink]="'/cards'">{{ 'home-page-content.go_to_profile' | translate }}</span>
      }

      <span class="hamburger-menu-item" (click)="isLanguageChangeOpened = !isLanguageChangeOpened">
        {{ 'home-page-content.lang' | translate }}
        <mat-icon class="hmi__arrow" [ngClass]="isLanguageChangeOpened ? 'opened' : ''">keyboard_arrow_down</mat-icon>
      </span>
      <div class="language-change-container"
        [ngClass]="isLanguageChangeOpened ? 'opened' : 'closed'"
      >
        <div class="language-change-option lco__top" [class.active]="isCurrentLang(Language.HY)" (click)="changeLang(Language.HY)">{{Language.HY | uppercase}}</div>
        <div class="language-change-option lco__middle" [class.active]="isCurrentLang(Language.EN)" (click)="changeLang(Language.EN)">{{Language.EN | uppercase}}</div>
        <div class="language-change-option lco__bottom" [class.active]="isCurrentLang(Language.RU)" (click)="changeLang(Language.RU)">{{Language.RU | uppercase}}</div>
      </div>
    </div>
  </section>
</main>

<mat-menu #languageChange='matMenu' xPosition="before" yPosition="below">
  <p class="cursor-pointer text-center m-0" (click)="changeLang(Language.HY)">{{Language.HY | uppercase}}</p>
  <hr class="lang-mat-menu-hr">
  <p class="cursor-pointer text-center m-0" (click)="changeLang(Language.EN)">{{Language.EN | uppercase}}</p>
  <hr class="lang-mat-menu-hr">
  <p class="cursor-pointer text-center m-0" (click)="changeLang(Language.RU)">{{Language.RU | uppercase}}</p>
</mat-menu>
